<template>
    <div class="evaluate">
        <div class="information_teacher">
            <img :src="headerImageStr(t_info.lecturerHeadUrl)" alt="">
            <div>
                <div>{{ t_info.lecturerName || "暂无讲师" }}</div>
                <div>{{ t_info.lecturerIntro || "暂无简介" }}</div>
                <div @click="dialogVisible = true">去评价</div>
            </div>
        </div>
        <div class="information_list">
            <div v-for="(item, index) in eva_list" :key="index">
                <img :src="item.headUrl" alt="">
                <div>
                    <div>{{ item.nickname }}</div>
                    <div>
                        <el-rate v-model="item.score" :colors="colors" disabled></el-rate>
                    </div>
                    <div>{{ item.evaluate }}</div>
                </div>
            </div>
        </div>
        <div style="color:#ccc;padding-bottom:10px;" v-if="eva_list.length == 0">
            暂无更多评价
        </div>
        <el-dialog style="text-align: left;" :show-close="false" center :visible="dialogVisible" width="30%">
            <div class="dia_title">
                <div>我的评价</div>
            </div>
            <textarea class="input_evaluate" v-model="input_eva" id="" maxlength="500"></textarea>
            <el-rate v-model="value2" :colors="colors" style="text-align: right;"></el-rate>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button style="margin-left: 50px;background-color: #4256FB;" type="primary" @click="add_eva">提
                    交</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import defaultheader from '@/assets/lives/theader.png'

export default {
    name: 'evaluate',
    comments: {

    },
    props: {

    },
    computed: {
        headerImageStr() {
            return (value) => {
                return value ? value : defaultheader
            }
        }
    },
    mounted() {

        this.$api.getLecturerInfo(JSON.parse(localStorage.getItem('livedetail')).lecturerId).then(res => {
            this.t_info = {
                lecturerHeadUrl: res.data.data.profile,
                lecturerIntro: res.data.data.teacherIntroduce,
                lecturerName: res.data.data.name,
            }
        })
        this.get_list(JSON.parse(localStorage.getItem('livedetail')).lecturerId)
    },
    data() {
        return {
            value1: 4,
            eva_list: [],
            value2: 0,
            colors: ['#99A9BF', '#F7BA2A', '#FF9900'],
            dialogVisible: false,
            input_eva: '',
            t_info: {}
        }
    },
    methods: {
        get_list(e) {
            this.$api.getAllPassEvaluate(e).then(res => {
                console.log("getAllPassEvaluate", res);
                this.eva_list = res.data.data
            })
        },
        add_eva() {
            if (this.input_eva.length == 0) {
                this.$message({
                    message: "请输入评价内容",
                    type: "error"
                })
            }
            else if (this.value2 == 0) {
                this.$message({
                    message: "分值最少1分",
                    type: "error"
                })
            }
            else {
                var nname = localStorage.getItem('user_name')
                if (localStorage.getItem('iswx') == 0 && localStorage.getItem('logtpye') == 4) {
                    nname = localStorage.getItem('user_name1')
                }
                this.$api.addTeacherEvaluate(
                    JSON.parse(localStorage.getItem('livedetail')).lecturerId,
                    localStorage.getItem('user_headimg'),
                    localStorage.getItem('user_account'),
                    nname,
                    this.input_eva,
                    this.value2
                ).then(res => {
                    console.log('addTeacherEvaluate', res);
                    this.dialogVisible = false
                    if (res.data.code === 200) {
                        this.$message({
                            message: "提交成功",
                            type: "success"
                        })
                    }
                    else {
                        this.$message({
                            message: "每天只可提交一次评价",
                            type: "warning"
                        })
                    }

                })
            }
        },
    },

}
</script>
<style scoped>
.evaluate {
    width: 90vw;
}

.input_evaluate {
    resize: none;
    padding: 10px;
    margin-top: 20px;
    margin-bottom: 20px;
    height: 200px;
    border-radius: 10px;
    border: 1px solid #CCCCCC;
    width: 96%;
    outline: none;
}

.dia_title {
    width: 100%;
    height: 62px;
    line-height: 62px;
    border-bottom: 1px solid #ECECEC;
    font-size: 20px;
    margin-top: -55px;
}

.dia_title>div {
    width: 17%;
    border-bottom: 4px solid #04BAF3;
}

.information_teacher {
    text-align: left;
    height: 178px;
    border-bottom: 1px solid #ECECEC;
}

.information_teacher img {
    float: left;
    margin: 34px 24px 24px 32px;
    width: 120px;
    height: 120px;
    border-radius: 50%;
}

.information_teacher>div {
    margin-top: 34px;
    width: 80%;
    float: left;
}

.information_teacher>div div:first-child {
    font-size: 16px;
    font-weight: 550;
    margin-bottom: 5px;
}

.information_teacher>div div:nth-child(2) {
    font-size: 14px;
    width: 50%;
    height: 44px;
    overflow-y: scroll;
    margin-bottom: 26px;
}

.information_teacher>div div:nth-child(2)::-webkit-scrollbar {
    width: 0px;
}

.information_teacher>div div:last-child {
    width: 58px;
    height: 24px;
    background: linear-gradient(153deg, #04BAF3 0%, #256EE7 96%);
    border-radius: 5px;
    text-align: center;
    font-size: 14px;
    line-height: 24px;
    color: #FFFFFF;
    cursor: pointer;
}

.information_list {
    text-align: left;
    width: 80%;
    margin-left: 67px;
    padding-bottom: 80px;
}

.information_list>div {
    margin-top: 30px;
    overflow: hidden;
}

.information_list>div>div {
    width: 70%;
    float: left;
}

.information_list img {
    width: 50px;
    height: 50px;
    margin-right: 16px;
    border-radius: 50%;
    float: left;
}

.information_list>div>div div:first-child {
    color: #999999;
    margin-bottom: 8px;
}
</style>
